<template>
    <div class="modal fade modal-dialog-scrollable" id="editInfoModal" tabindex="-1"
        aria-labelledby="editInfoModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="editInfoModalLabel">お知らせ登録・変更</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        tabindex="-1"></button>
                </div>
                <div class="modal-body">
                    <table id="result-tbl" class="table align-middle table-sm table-bordered table-hover text-center">
                        <tbody>
                            <tr>
                                <th>キー</th>
                                <td><input type="text" v-model="infoKey"> <button type="button" class="btn btn-sm btn-primary" @click="loadInfo()">ロード</button></td>
                            </tr>
                            <tr>
                                <th>表示</th>
                                <td>
                                    <input type="radio" name="visible" tabindex="3" v-model="info.visible" value="1"> 表示&nbsp;&nbsp;&nbsp;&nbsp;
                                    <input type="radio" name="visible" tabindex="3" v-model="info.visible" value="0"> 非表示
                                </td>
                            </tr>
                            <tr>
                                <th scope="col" width="100px">日時</th>
                                <td style="text-align: left;"><input type="text" style='width: 150px;' tabindex="1" v-model="info.timestamp"/></td>
                            </tr>
                            <tr>
                                <th scope="col">メッセージ</th>                                
                                <td style="text-align: left;"><textarea tabindex="2" cols="35" rows="10" v-model="info.message"></textarea></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <div style="display: flex; justify-content: space-between; width: 100%;">
                        <div style="width:50%; text-align:left;"><button type="button" class="btn btn-sm btn-secondary" tabindex="5" data-bs-dismiss="modal">キャンセル</button></div>
                        <div style="width:50%; text-align:right;"><button type="button" class="btn btn-sm btn-primary" tabindex="3" data-bs-dismiss="modal" @click="saveInfoValue()">保存する</button></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>

<script setup>
import { ref, onMounted } from 'vue';
import { ref as fbRef, getDatabase, child, get, update } from "firebase/database"
const db = getDatabase();
const dbRef = fbRef(db);

const timestamp = ref();
const message = ref();
const info = ref([]);
const infoKey = ref();

onMounted(() => {
    timestamp.value = "2024.04.10 10:20"
})

const loadInfo = async () => {
    await get(child(dbRef, '/2026-summer/info/' + infoKey.value))
    .then(async (snapshot) => {
        if (snapshot.exists()) {
            info.value = snapshot.val();
        }
    });
}

const saveInfoValue = async () => {

    const updates = {};
    updates['/2026-summer/info/' + infoKey.value] = info.value;
    await update(dbRef, updates)
    .then(async () => {
        console.log("info(" + infoKey.value + ") was updated succssfully.")
    })
    .catch((error) => {
        console.error(error)
        throw(error)
    });
}

</script>